import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, ExternalLink } from 'lucide-react';



const begambleawareImg = '/images/begambleaware.png';
const gamblingCommissionImg = '/images/gambling_commission_logo.png';
const gamcareImg = '/images/gamcare.png';
const gamstopImg = '/images/gamstop_logo.png';
const ageRestrictionImg = '/images/18+.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brown-900  text-beige-100">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand Column */}
          <div itemScope itemType="https://schema.org/Organization">
            <Link to="/" data-discover="true" className="flex items-center space-x-2 mb-4">
              <img 
                src="/images/favicon.webp" 
                alt="Sterling Spins Logo" 
                itemProp="logo"
                className="w-10 h-10 rounded-lg"
              />
              <span className="text-2xl font-bold text-white" itemProp="name">Sterling Spins</span>
            </Link>
            <p className="text-beige-300 text-sm leading-relaxed" itemProp="description">
              Your trusted guide to the UK's best online casinos. Independent reviews, expert insights, and exclusive bonuses.
            </p>
            <p itemProp="email">Email: info@sterling-spins.com</p>
            <p itemProp="telephone">Phone: +44 0973 385 308</p>
            <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
              <p>Address: <span itemProp="addressLocality">London</span>, <span itemProp="addressCountry">United Kingdom</span></p>
            </div>
          </div>

          

          

          <div>
            <h3 className="text-white font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/guides" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Guides
                </Link>
              </li>
              <li>
                <Link to="/news" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  News
                </Link>
              </li>
              <li>
                <Link to="/reviews" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Reviews
                </Link>
              </li>
            </ul>
          </div>




          <div>
            <h3 className="text-white font-bold mb-4">Legal links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-conditions" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/responsible-gaming" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Responsible Gaming
                </Link>
              </li>
            </ul>
          </div>



          <div>
            <h3 className="text-white font-bold mb-4">Responsible Gaming</h3>
            <div className="flex flex-wrap justify-center items-center gap-6 md:gap-8 mb-8">
              <div className="flex items-center">
                <a
                    href="https://www.begambleaware.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                  <img
                      className="h-[60px] w-auto object-contain"
                      alt="BeGambleAware - Responsible Gambling"
                      src={begambleawareImg}
                  />
                </a>
              </div>

              <div className="flex items-center">
                <a
                    href="https://www.gamblingcommission.gov.uk/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                  <img
                      className="h-[60px] w-auto object-contain"
                      alt="UK Gambling Commission"
                      src={gamblingCommissionImg}
                  />
                </a>
              </div>

              <div className="flex items-center">
                <a
                    href="https://www.gamcare.org.uk/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                  <img
                      className="h-[60px] w-auto object-contain"
                      alt="GamCare - Gambling Support"
                      src={gamcareImg}
                  />
                </a>
              </div>

              <div className="flex items-center">
                <a
                    href="https://www.gamstop.co.uk/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                  <img
                      className="h-[60px] w-auto object-contain"
                      alt="Gamstop - Self-Exclusion"
                      src={gamstopImg}
                  />
                </a>
              </div>

              <div className="flex items-center">
                <img
                    className="h-[60px] w-auto object-contain"
                    alt="18+ Age Restriction"
                    src={ageRestrictionImg}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Disclaimer Section */}
        <div className="border-t border-brown-800 pt-8 mt-8">
          <div className="max-w-4xl mx-auto">
            <p className="text-beige-300 text-sm leading-relaxed text-center">
              Sterling Spins operates as an independent review and comparison platform. Certain links featured on our website 
              may be affiliate links, which means we could receive compensation if you choose to click through or register 
              with a partner casino. This compensation structure does not influence our editorial decisions, reviews, ratings, 
              or recommendations in any way. Our content remains objective and player-focused. This service is intended for 
              individuals aged 18 and over only. We strongly encourage responsible gambling practices. If you need support, 
              please visit{' '}
              <a 
                href="https://www.begambleaware.org" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-beige-200 hover:text-white underline inline-flex items-center space-x-1"
              >
                <span>BeGambleAware.org</span>
                <ExternalLink className="w-3 h-3" />
              </a>
              . All terms and conditions apply to offers and promotions listed on this site.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

